import { DropDown, DropDownContainer, DropDownElement } from './style'

export type OptionDropdown = {
  id: string | number
  value: string | number
  dropDownValue: JSX.Element
  isCurrentPrice: boolean
}

export type DropDownTableProps = {
  options: OptionDropdown[]
  onClick: (value: string | number) => void
}

export const DropDownTable = ({ options, onClick }: DropDownTableProps) => {
  return (
    <DropDownContainer>
      <DropDown>
        {options.map((option) => {
          if (option?.dropDownValue) {
            return (
              <DropDownElement
                isCurrentPrice={option.isCurrentPrice}
                key={option.id}
                onClick={() => onClick(option.id)}
              >
                {option.dropDownValue}
              </DropDownElement>
            )
          }
          return (
            <DropDownElement key={option.id} onClick={() => onClick(option.id)}>
              {option.value}
            </DropDownElement>
          )
        })}
      </DropDown>
    </DropDownContainer>
  )
}
